import React, { Fragment } from 'react'
import firebase from './firebase'

const deleteItem = id => {
  firebase
    .firestore()
    .collection('casamentokaju')
    .doc(id)
    .delete()
}

const notAdminView = listItem => {
  const innerWidth = window.innerWidth
  return (
    <Fragment>
      <table>
        <tbody>
          <tr>
            <th>Musicas - Bandas/Artistas</th>
          </tr>
        </tbody>
      </table>
      <table className='table-content-max-height'>
        <tbody>
        {innerWidth >= 521 ? (
          listItem.map(item => (
            <tr key={item.id}>
              <td>{item.music1}</td>
              <td>{item.music2}</td>
            </tr>
          ))
        ) : (
          listItem.map(item => (
            <tr key={item.id}>
              <td><span>{item.music1}</span><span>{item.music2}</span></td>
            </tr>
          ))
        )}
        </tbody>
      </table>
    </Fragment>
  )
}

const ItemList = (props) => {
  const listItem = props.completeList

  if (props.property === 'userView') {
    return notAdminView(listItem)
  }

  return (
    <div>
      {listItem.map(item => (
        <div className='box-message' key={item.id}>
          <div className='text'>
            <div className='item'>
              <span>Nome</span>
              <p>{item.name}</p>
            </div>
            <div className='item'>
              <span>Telefone</span>
              <p><a href={`https://api.whatsapp.com/send?phone=55${item.phone}`}>{item.phone}</a></p>
            </div>
            <div className='item'>
              <span>Cidade</span>
              <p>{item.town.town}/{item.uf.uf}</p>
            </div>
            <div className='item'>
              <span>Musica 1</span>
              <p>{item.music1}</p>
            </div>
            <div className='item'>
              <span>Musica 2</span>
              <p>{item.music2}</p>
            </div>
            <div className='item'>
              <span>Mensagem</span>
              <p>{item.message}</p>
            </div>
          </div>
          <div className='action-buttons'>
            <button onClick={() => deleteItem(item.id)}><i className="far fa-trash-alt" /></button>
            {item.show ? (
              <button onClick={() => props.onPinClick({ item }, false)}><i className="far fa-comments" /></button>
            ) : (
              <button onClick={() => props.onPinClick({ item }, true)}><i className="fas fa-comment-slash" /></button>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
export default ItemList



// WEBPACK FOOTER //
// ./src/components/itemList.js